module.exports = __webpack_public_path__ + "static/media/upload-file.b3e910cd.svg";